export default __webpack_public_path__ + "images/495982e8a4bce6b2187e821e15281535.png";